module.exports = __webpack_public_path__ + "img/visa.dc346948.svg";